import React, { Component } from 'react'

// import Plyr from '../components/plyr'
// import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class VimeoVideoAutoplay extends Component {

  render() {

  	let { vimeoVideoId, fullwidth, bgc } = this.props

    return (
      <div>
        {(() => {
          if (fullwidth === 'enable') {
            return (
              <section className='video' style={{backgroundColor:bgc}}>

                <div className='video-container-autoplay'>
                  <iframe title={'StudioSmall' + vimeoVideoId} src={'https://player.vimeo.com/video/' +vimeoVideoId +'?background=1'} width="100%" height="100%" frameBorder="0" allowFullScreen></iframe>
                </div>

                {/* <Plyr
                    type='vimeo'
                    ref='player'
                    videoId={ vimeoVideoId }
                    autoplay={ true }
                    muted={true}
                    controls={ ['play', 'volume'] }
                    // vimeo= { 'background: 0' }
                    urls={{
                      vimeo: {
                        api: 'https://noembed.com/embed?url={0}'
                      }
                    }}
                  /> */}
            </section>
            )
          } else {
            return (
              <section className='video' style={{backgroundColor:bgc}}>
              <div className='video-project'>
              <div className='video-project__contained'>
                <div className='video-container-autoplay'>
                  <iframe title={'StudioSmall' + vimeoVideoId} src={'https://player.vimeo.com/video/' +vimeoVideoId +'?background=1'} width="100%" height="100%" frameBorder="0" allowFullScreen></iframe>
                </div>
                {/* <Plyr
                    type='vimeo'
                    ref='player'
                    videoId={ vimeoVideoId }
                    autoplay={ true }
                    muted={true}
                    controls={ ['play', 'volume'] }
                    // vimeo= { 'background: 0' }
                    urls={{
                      vimeo: {
                        api: 'https://noembed.com/embed?url={0}'
                      }
                    }}
                  /> */}
              </div>
            </div>
            </section>
            )
          }
        })()}
      </div>
    )
  }
}

export default VimeoVideoAutoplay
